import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';

import { useTranslation } from 'react-i18next';

import clsx from 'clsx';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  InputLabel,
  Switch,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';

import { Save } from '@material-ui/icons';

import { toast } from 'react-toastify';

import { GroupsTablePermission } from '../index';

import { useStyles } from './styles';
import { GroupsData } from 'services/dataService';
import { statusGroups } from 'constants/status';

export default ({ className, isModalInsert, ...rest }) => {
  const [type, setType] = useState(0);
  const [loading, setLoading] = useState(true);
  const [permissionData, setPermissionData] = useState([]);
  const { id } = useParams();

  const { register, handleSubmit, errors, setValue, control } = useForm();
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation([
    'title',
    'form',
    'label',
    'button',
    'validation',
    'toastify',
  ]);

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        try {
          const response = await GroupsData.getGroupById(id);

          const responsePermission = await GroupsData.getPermissionsById({
            id_group: id,
          });

          const { name, type } = response.data;

          const permissions = responsePermission.data.map((elem) => {
            return {
              id: elem.id,
              name: elem.route.name,
              method_get: elem.method_get,
              method_post: elem.method_post,
              method_put: elem.method_put,
              method_delete: elem.method_delete,
            };
          });

          setPermissionData(permissions);
          setType(type);
          setValue([{ name }, { type }]);
        } catch (err) {
          history.push('/groups');
          if (err.response?.status === 403) {
            toast.error(t('toastify:commons.toast_error_403'));
          } else {
            toast.error(t('toastify:commons.toast_error_api'));
          }
        }
      };

      fetchData();
    }
    setLoading(false);
  }, [id, t]);

  const onSubmit = async (data) => {
    try {
      if (id) {
        permissionData.map(
          async (elem) =>
            await GroupsData.updatePermissions(elem.id, {
              method_get: elem.method_get,
              method_post: elem.method_post,
              method_put: elem.method_put,
              method_delete: elem.method_delete,
            })
        );

        await GroupsData.updateGroup(id, data);
        toast.success(t('toastify:commons.toast_update'));
      } else {
        await GroupsData.addGroup(data);
        toast.success(t('toastify:commons.toast_success'));
      }
      if (!isModalInsert) history.push('/groups');
      if (isModalInsert) isModalInsert(false);
      setValue([{ name: '' }]);
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error(t('toastify:commons.toast_error_403'));
      } else {
        const toastMsg = id ? 'toast_update_error' : 'toast_error';
        toast.error(t(`toastify:commons.${toastMsg}`));
      }
    }
  };

  const handleStatusChange = () => {
    setType((prev) => !prev);
  };

  const titlePage = id
    ? t('title:Groups.title_edit')
    : t('title:Groups.title_create');

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title={titlePage} />
      <Divider />
      {!loading && (
        <form
          {...rest}
          className={clsx(classes.root, className)}
          onSubmit={handleSubmit(onSubmit)}
        >
          <CardContent>
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth
                  label={t('form:Group.input_group')}
                  helperText={
                    errors.name?.type === 'required' &&
                    t('validation:commons.validation_required', {
                      field: t('form:Group.input_group'),
                    })
                  }
                  name="name"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputRef={register({ required: true })}
                  error={!!errors.name}
                />
              </Grid>

              <Grid item md={3} xs={12}>
                <FormControl style={{ minWidth: 100 }}>
                  <InputLabel id="type">
                    {t('form:commons.input_type')}
                  </InputLabel>

                  <Controller
                    as={
                      <Select>
                        <MenuItem key={1} value={1}>
                          {t(statusGroups[1]?.title)}
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          {t(statusGroups[2]?.title)}
                        </MenuItem>
                      </Select>
                    }
                    name="type"
                    control={control}
                    defaultValue={type}
                    value={type}
                    inputRef={register({ required: true })}
                  />
                </FormControl>
              </Grid>
            </Grid>

            {id && (
              <Grid container spacing={3}>
                <Grid item md={12}>
                  <GroupsTablePermission
                    data={permissionData}
                    setData={setPermissionData}
                  />
                </Grid>
              </Grid>
            )}
          </CardContent>

          <Divider />
          <CardActions className={classes.actions}>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              size="large"
            >
              {t('button:commons.btn_save')}
              <Save />
            </Button>
          </CardActions>
        </form>
      )}
    </Card>
  );
};
